import { SET_CURRENT_ROOT_ACCOUNT } from './actionTypes';

const setCurrentRootAccount = account => ({
    type: SET_CURRENT_ROOT_ACCOUNT,
    payload: account,
});

export default setCurrentRootAccount;
